/* crete an arrow components called FieldErrors */

import { errorsLabels } from '../constants/errorsLabels';

const FieldErrors = ({ hasErrors, errors }: { hasErrors: number; errors: string[] }) => {
  if (hasErrors == undefined) {
    return null;
  }

  return (
    <div className="text-red-600">
      {errors?.map((error: string) => <div key={error}>{errorsLabels[error] || error}</div>)}
    </div>
  );
};

export default FieldErrors;
